module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.saving || _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modalContent"
  }, [_c('span', {
    staticClass: "uppercase listTitle bold"
  }, [_vm._v(_vm._s(_vm.campaign.name))]), _vm._v(" "), _c('h1', [_vm._v("Edit campaign")]), _vm._v(" "), _c('form', {
    staticClass: "form_campaing"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("editCampaign.name")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.campaign.name),
      expression: "campaign.name",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "maxlength": _vm.MAX_LENGTH_NAME,
      "minlength": "5"
    },
    domProps: {
      "value": (_vm.campaign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campaign.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("editCampaign.shortName")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.campaign.shortName),
      expression: "campaign.shortName",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.campaign.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campaign.shortName = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("editCampaign.lastCampaign")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastCampaign),
      expression: "lastCampaign"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lastCampaign = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "uppercase",
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v(" " + _vm._s(_vm.$trad.campaignCreate.previousCampaign))]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      key: campaign.id,
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(" " + _vm._s(campaign.name) + " ")])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("editCampaign.launch")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.launchDate),
      expression: "campaign.launchDate"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.campaign.launchDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campaign.launchDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("editCampaign.end")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.endDate),
      expression: "campaign.endDate"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.campaign.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campaign.endDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('footer', {
    staticClass: "flexContainer"
  }, [_c('RoundedButton', {
    attrs: {
      "className": 'block uppercase save',
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.saveEditCampaign();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("editCampaign.save")) + "\n        ")]), _vm._v(" "), _c('RoundedButton', {
    attrs: {
      "className": 'block uppercase save'
    },
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), (_vm.hasAccessDelete('campaign_manager')) ? _c('RoundedButton', {
    attrs: {
      "className": 'block uppercase'
    },
    on: {
      "click": function($event) {
        _vm.deleteEditedCampaign();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("editCampaign.delete")))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-764f0f82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/EditCampaign.vue
// module id = 3274
// module chunks = 0